import React from 'react'
import { MasteryLevel, ScoreboardData, masteryLevels } from '../../Types'
import { Col, Row, Container } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar } from '@fortawesome/free-solid-svg-icons'
import { Tooltip } from '../../components/Tooltip'

import './ScoreboardView.scss'

type MasteryStarProps = {
    levelAchieved: number
    masteryLevel: MasteryLevel
}

const MasteryStar = ({ levelAchieved, masteryLevel }: MasteryStarProps) => {
    return (
        <Col className={levelAchieved > masteryLevel.level ? 'reached' : 'notYetReached'}>
            <Row>
                <FontAwesomeIcon icon={faStar} size="4x" />
            </Row>
            <Row className={'level'}>
                {masteryLevel.name}
            </Row>
        </Col>
    )
}

export const ScoreboardView: React.FC<ScoreboardData> = ({ levelAchieved, overallScore, faultsAttempted, faultsSolved, faultPercentage, safetyScore, accuracyScore, efficiencyScore, skillRating }: ScoreboardData) => {

    const masteryStars = masteryLevels.map((level: MasteryLevel, key: number) => <MasteryStar levelAchieved={levelAchieved.value} masteryLevel={level} key={'ml' + key} />)
    return (
        <>
            <Tooltip />
            <Container className="pre-fault" fluid={true}>
                <Row>
                    <Col>
                        <div className={'title'}>
                            {'Your Scoreboard'}
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Row className="overallScore">
                            <div
                                data-place={'bottom'}
                                data-tip={overallScore.description}
                            >
                                {overallScore.value}
                            </div>
                        </Row>
                    </Col>
                </Row>
                <Row className={'userOverview'}>
                    <Col className={'userLevel'}>
                        <Row className={'userTitle'}>
                            {'Achievements'}
                        </Row>
                        <Row
                            data-place={'right'}
                            data-tip={levelAchieved.description}
                            className={'levels'}
                        >
                            {masteryStars}
                        </Row>
                    </Col>
                    <Col className={'userStats'}>
                        <Row className={'userStat'}>
                            <Col className={'statTitle'}>
                                {'Faults Attempted'}
                            </Col>
                            <Col className={'stat'}>
                                {faultsAttempted}
                            </Col>
                        </Row>
                        <Row className={'userStat'}>
                            <Col className={'statTitle'}>
                                {'Faults Solved'}
                            </Col>
                            <Col className={'stat'}>
                                {faultsSolved}
                            </Col>
                        </Row>
                        <Row className={'userStat'}>
                            <Col className={'statTitle'}>
                                {'Percentage Solved'}
                            </Col>
                            <Col className={'stat'}>
                                {faultPercentage + '%'}
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row className={'trends'}>
                    <Col
                        className={'trendBox'}
                        data-tip={safetyScore.description}
                    >
                        <Row className={'trendType'}>
                            {safetyScore.name}
                        </Row>
                        <Row className={'innerTrendBox'}>
                            <Col>
                                <Row className={'trendTitle'}>
                                    {'Overall'}
                                </Row>
                                <Row className={'trendPercentage'}>
                                    {safetyScore.value + '%'}
                                </Row>
                            </Col>
                            {/*<Col>*/}
                            {/*    <Row className={"trendTitle"}>*/}
                            {/*        {'Trend'}*/}
                            {/*    </Row>*/}
                            {/*    <Row>*/}
                            {/*        <FontAwesomeIcon icon={faMinus} size="2x"/>*/}
                            {/*    </Row>*/}
                            {/*</Col>*/}
                        </Row>
                    </Col>
                    <Col
                        className={'trendBox'}
                        data-tip={accuracyScore.description}
                    >
                        <Row className={'trendType'}>
                            {accuracyScore.name}
                        </Row>
                        <Row className={'innerTrendBox'}>
                            <Col>
                                <Row className={'trendTitle'}>
                                    {'Overall'}
                                </Row>
                                <Row className={'trendPercentage'}>
                                    {accuracyScore.value + '%'}
                                </Row>
                            </Col>
                            {/*<Col>*/}
                            {/*    <Row  className={"trendTitle"}>*/}
                            {/*        {'Trend'}*/}
                            {/*    </Row>*/}
                            {/*    <Row>*/}
                            {/*        <FontAwesomeIcon icon={faMinus} size="2x" />*/}
                            {/*    </Row>*/}
                            {/*</Col>*/}
                        </Row>
                    </Col>
                    <Col
                        className={'trendBox'}
                        data-tip={efficiencyScore.description}
                    >
                        <Row className={'trendType'}>
                            {efficiencyScore.name}
                        </Row>
                        <Row className={'innerTrendBox'}>
                            <Col>
                                <Row className={'trendTitle'}>
                                    {'Overall'}
                                </Row>
                                <Row className={'trendPercentage'}>
                                    {efficiencyScore.value + '%'}
                                </Row>
                            </Col>
                            {/*<Col>*/}
                            {/*    <Row className={"trendTitle"}>*/}
                            {/*        {'Trend'}*/}
                            {/*    </Row>*/}
                            {/*    <Row>*/}
                            {/*        <FontAwesomeIcon icon={faMinus} size="2x" />*/}
                            {/*    </Row>*/}
                            {/*</Col>*/}
                        </Row>
                    </Col>
                    <Col
                        className={'trendBox'}
                        data-tip={skillRating.description}
                    >
                        <Row className={'trendType'}>
                            {skillRating.name}
                        </Row>
                        <Row className={'innerTrendBox'}>
                            <Col>
                                <Row className={'trendTitle'}>
                                    {'Overall'}
                                </Row>
                                <Row className={'trendPercentage'}>
                                    {skillRating.value + '%'}
                                </Row>
                            </Col>
                            {/*<Col>*/}
                            {/*    <Row className={"trendTitle"}>*/}
                            {/*        {'Trend'}*/}
                            {/*    </Row>*/}
                            {/*    <Row>*/}
                            {/*        <FontAwesomeIcon icon={faMinus} size="2x" />*/}
                            {/*    </Row>*/}
                            {/*</Col>*/}
                        </Row>
                    </Col>
                </Row>
            </Container>
        </>
    )
}
